<template>
  <div v-if="item?.assignments?.employee?.name">
    {{ item?.assignments?.employee?.name }}
  </div>
  <div v-else>
    {{ item?.name }}
  </div>
</template>
<script>
export default {
  props: ["item"],
};
</script>
